import { getPageData } from '@realestate.com.au/iglu-data';

export const getHomePageDataGetter = () =>
  getPageData({
    pageType: 'homepage',
    siteSection: 'home',
    site: 'pca',
  });
